module.exports = __webpack_public_path__ + "media/fastweb_volunteers/dosomething_Thumbwars_351x242-e43f0a9d.jpg";